import ColorPicker from "../ColorPicker";
import PageTitleSubtitle from "../PageTitleSubTitle";

export default function FieldColor({
  fieldTitle,
  fieldSubtitle,
  fieldName,
  handleValueChange,
  fieldValue,
  customMinWidth,
}) {
  return (
    <div className="w-full flex justify-between items-center my-2 gap-2">
      <div>
        <PageTitleSubtitle
          useFieldTitleStyle
          useEventTitleStyle
          title={fieldTitle}
          subtitle={fieldSubtitle}
        />
      </div>
      <div style={{ minWidth: customMinWidth ?? "250px" }}>
        <ColorPicker
          value={fieldValue}
          name={fieldName}
          onChange={handleValueChange}
        />
      </div>
    </div>
  );
}
